module.exports = __webpack_public_path__ + "static/media/repeat.c136681c.svg";